export class FieldItemModel {
    id = 0;
    name = "";
    sortOrder = 0;
    enabled = true;
}
